import { FormattedMessage, useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

import { SeoHead } from 'modules/seo';
import { useWorkorderDocuments, WorkorderType } from 'modules/entities/modules/workorder-documents';

import { DocumentInfo } from '../DocumentInfo';
import { RiskAssessmentReportsSearchPanel } from '../RiskAssessmentReportsTab/RiskAssessmentReportsSearchPanel';
import { RiskAssessmentReportsActionPanel } from '../RiskAssessmentReportsTab/RiskAssessmentReportsActionPanel';
import { RiskAssessmentReportsTable } from '../RiskAssessmentReportsTab/RiskAssessmentReportsTable';

export const FlapTab = () => {
    const intl = useIntl();
    const { loading, documents, defaultSearch } = useWorkorderDocuments(WorkorderType.FLAP);
    const match = useRouteMatch('/elevators/:id');

    return (
        <>
            <SeoHead title={intl.formatMessage({ id: 'documents.flap.title' })} />
            <DocumentInfo>
                <FormattedMessage id="documents.flap.info" />
            </DocumentInfo>
            <RiskAssessmentReportsSearchPanel defaultValue={defaultSearch} isElevatorDetail={match?.isExact} />
            <RiskAssessmentReportsActionPanel documents={documents} />
            <RiskAssessmentReportsTable loading={loading} documents={documents} />
        </>
    );
};
